import React, { useState, useEffect, useRef } from "react";

const Malayalam = () => {
  const [text, setText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedLang, setSelectedLang] = useState("ml");
  const [showDropdown, setShowDropdown] = useState(false);

  const debounceRef = useRef(null);
  const inputRef = useRef(null);

  // 🔹 Fetch Suggestions (Debounced)
  useEffect(() => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchSuggestions();
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [text, selectedLang]);

  const fetchSuggestions = async () => {
    let words = text.split(" ");
    let lastWord = words[words.length - 1];

    if (!lastWord.trim()) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    try {
      let response = await fetch(
        `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
      );

      let data = await response.json();

      if (data[0] === "SUCCESS") {
        setSuggestions(data[1][0][1]);
        setShowDropdown(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Handle Space (Auto Convert)
  const handleKeyDown = async (e) => {
    // ✅ ENTER → allow new line
    if (e.key === "Enter") {
      setShowDropdown(false);
      return;
    }
  
    // ✅ SPACE → convert last word
    if (e.key === " ") {
      e.preventDefault();
  
      // ✅ ENGLISH → no conversion
      if (selectedLang === "en") {
        setText((prev) => prev + " ");
        setSuggestions([]);
        setShowDropdown(false);
        return;
      }
  
      let parts = text.split(/(\s+)/);
  
      // 🔍 Find last actual word
      let lastIndex = -1;
      for (let i = parts.length - 1; i >= 0; i--) {
        if (!parts[i].trim().match(/^\s+$/) && parts[i].trim() !== "") {
          lastIndex = i;
          break;
        }
      }
  
      // ✅ No word → just add space
      if (lastIndex === -1) {
        setText((prev) => prev + " ");
        return;
      }
  
      let lastWord = parts[lastIndex];
  
      try {
        let response = await fetch(
          `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
        );
  
        let data = await response.json();
  
        // ✅ SAFE conversion
        if (
          data[0] === "SUCCESS" &&
          data[1] &&
          data[1][0] &&
          data[1][0][1] &&
          data[1][0][1].length > 0
        ) {
          parts[lastIndex] = data[1][0][1][0];
        } else {
          parts[lastIndex] = lastWord; // fallback
        }
      } catch (err) {
        console.error(err);
        parts[lastIndex] = lastWord; // fallback
      }
  
      setText(parts.join("") + " ");
      setSuggestions([]);
      setShowDropdown(false);
    }
  
    // ✅ ALL OTHER KEYS → do nothing (allow typing)
  };

  // 🔹 Click Suggestion
  const selectSuggestion = (value) => {
    let words = text.split(" ");
    words[words.length - 1] = value;

    setText(words.join(" ") + " ");
    setSuggestions([]);
    setShowDropdown(false);

    inputRef.current.focus();
  };

  return (
    <div style={{ padding: "40px", fontFamily: "Noto Sans Malayalam" }}>
      
      {/* 🌍 Language Dropdown */}
      <select
        value={selectedLang}
        onChange={(e) => setSelectedLang(e.target.value)}
        style={{ marginBottom: "10px", padding: "8px" }}
      >
        <option value="ml">Malayalam (മലയാളം)</option>
        <option value="hi">Hindi (हिंदी)</option>
        <option value="en">English (English)</option>
        <option value="ta">Tamil (தமிழ்)</option>
        <option value="te">Telugu (తెలుగు)</option>
        <option value="kn">Kannada (ಕನ್ನಡ)</option>
        <option value="bn">Bengali (বাংলা)</option>
        <option value="gu">Gujarati (ગુજરાતી)</option>
        <option value="mr">Marathi (मराठी)</option>
        <option value="pa">Punjabi (ਪੰਜਾਬੀ)</option>
        <option value="or">Odia (ଓଡ଼ିଆ)</option>
      </select>

      {/* 🧠 Input Box */}
      <div style={{ position: "relative", width: "300px" }}>
        <textarea
          ref={inputRef}
          type="text"
          value={text}
          placeholder="Type Manglish..."
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "18px",
            height:'500px',
          }}
        ></textarea>

        {/* 🔽 Suggestions Dropdown */}
        {showDropdown && suggestions.length > 0 && (
  <div
    style={{
      position: "absolute",
      top: "50px",
      width: "100%",
      background: "#ffffff",
      border: "1px solid #ddd",
      borderRadius: "8px",
      Height: "220px",
      overflowY: "auto",
      zIndex: 9999,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    }}
  >
    {suggestions.map((item, index) => (
      <div
        key={index}
        onClick={() => selectSuggestion(item)}
        style={{
          padding: "12px 16px",
          cursor: "pointer",
          fontSize: "18px",           // 🔥 bigger text
          color: "#000",              // 🔥 black text
          fontWeight: "500",
          borderBottom: "1px solid #f0f0f0",
        }}
        onMouseOver={(e) => {
          e.target.style.background = "#f5f5f5";
        }}
        onMouseOut={(e) => {
          e.target.style.background = "#fff";
        }}
      >
        {item}
      </div>
    ))}
  </div>
)}
      </div>
    </div>
  );
};

export default Malayalam;